<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-sheet elevation="3" class="pa-2" v-if="booking.customer">
        <h5 class="title">Customer</h5>
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="Restock at @HQ?"
                    v-model="restock"/>
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="Free format" v-model="hq"/>
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="Speed Block (Ignores Address)" v-model="booking.speedBlock"/>
        <v-text-field :disabled="booking.parentBookingId || booking.isApproved" v-if="hq"
                      label="Free Format Description" v-model="booking.customer.name" color="primary"/>
        <v-autocomplete v-model="booking.customer"
                        v-if="!restock && !hq"
                        :items="customers"
                        :loading="isLoading"
                        :search-input.sync="search"
                        color="primary"
                        hide-no-data
                        item-text="display"
                        placeholder="Start typing to Search"
                        return-object
                        clearable
                        no-filter
                        outlined
                        append-icon="mdi-account-search"
                        :disabled="booking.parentBookingId || booking.isApproved"
        />
        <div v-if="booking.customer.name">
          <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Company Name"
                        v-model="booking.customer.companyName" color="primary"/>
          <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Name"
                        v-model="booking.customer.name" color="primary"/>
          <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Email"
                        v-model="booking.customer.email" color="primary"/>
          <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Phone"
                        v-model="booking.customer.phone" color="primary"/>
          <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Mobile"
                        v-model="booking.customer.mobile" color="primary"/>
        </div>
      </v-sheet>
    </v-col>
    <v-col cols="12" sm="6">
      <v-sheet elevation="3" class="ml-1 pa-2" v-if="booking.customer.name && draw">
        <v-layout>
          <h5 class="title">Address</h5>
          <v-spacer/>
          <v-btn :disabled="booking.isApproved" @click="editAddress =! editAddress" icon color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click="searchForCloseBookings" color="secondary">Find nearby bookings</v-btn>
        </v-layout>
        <v-autocomplete
            v-if="editAddress || booking.customer.additionalAddress"
            v-model="selectedAddress"
            :items="addresses"
            :loading="isLoadingAddress"
            :search-input.sync="searchAddress"
            color="primary"
            hide-no-data
            item-text="line_1"
            placeholder="Start typing to Search"
            return-object
            clearable
            no-filter
            outlined
            append-icon="mdi-home-search"
        />
        <v-text-field :disabled="!editAddress" label="Address 1" v-model="booking.customer.address1" color="primary"/>
        <v-text-field :disabled="!editAddress" label="Address 2" v-model="booking.customer.address2" color="primary"/>
        <v-text-field :disabled="!editAddress" label="City" v-model="booking.customer.city" color="primary"/>
        <v-text-field :disabled="!editAddress" label="County" v-model="booking.customer.county" color="primary"/>
        <v-text-field :disabled="!editAddress" label="Postcode" v-model="booking.customer.postcode" color="primary"/>
        <v-checkbox :disabled="booking.isApproved" label="Additional Address?"
                    v-model="booking.customer.additionalAddress"
                    hint="Is the work being undertaken at a different address?" persistent-hint/>
        <div v-if="booking.customer.additionalAddress">
          <v-text-field label="Address 1" v-model="booking.customer.addAddress1" color="primary"/>
          <v-text-field label="Address 2" v-model="booking.customer.addAddress2" color="primary"/>
          <v-text-field label="City" v-model="booking.customer.addCity" color="primary"/>
          <v-text-field label="County" v-model="booking.customer.addCounty" color="primary"/>
          <v-text-field label="Postcode" v-model="booking.customer.addPostCode" color="primary"/>
        </div>
      </v-sheet>
    </v-col>

    <v-dialog width="40%" :value="closeBookings">
      <v-card>
        <v-card-title>Bookings Close By</v-card-title>
        <v-card-text>
          <v-data-iterator
              :items="nearByBookings"
          >
            <template v-slot:default="props">
              <v-row>
                <v-col
                    v-for="item in props.items"
                    :key="item._id"
                    cols="12"
                >
                  <v-card>
                    <v-card-title>{{item._id}} <span class="ml-2"> - Distance {{ (item.calculated / 1609).toFixed(1) }} miles</span></v-card-title>
                    <v-card-text>
                      <p>Date: {{item.startDate | moment('DD/MM/YYYY HH:mm')}}</p>
                      <p>Service: {{item.service}}</p>
                      <p v-if="item.phone">Phone: {{item.phone}}</p>
                      <p>Value: £{{item.sum}}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeBookings = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {CustomersHttp} from "@/http/CustomersHttp";
import {AddressHttp} from "@/http/AddressHttp";
import {BookingsHttp} from "@/http/BookingsHttp";

export default {
  name: "CustomerDetails",
  props: {
    booking: Object
  },
  data() {
    return {
      customers: [],
      isLoading: false,
      search: '',
      selected: {},
      editAddress: false,
      selectedAddress: {},
      addresses: [],
      isLoadingAddress: false,
      searchAddress: '',
      additionalAddress: false,
      restock: false,
      hq: false,
      draw: true,
      closeBookings: false,
      nearByBookings: []
    }
  },
  methods: {
    async searchForCloseBookings() {
      let postcode = this.booking.customer.postcode;
      if (this.booking.customer.additionalAddress) {
        postcode = this.booking.customer.addPostCode;
      }
      const { data } = await BookingsHttp.getBookingsByDistance(new Date(), postcode, false);
      // // eslint-disable-next-line no-console
      // console.log(data);
      this.closeBookings = true;
      this.nearByBookings = data;
    }
  },
  watch: {
    closeBookings(newVal) {
      if (!newVal) {
        this.nearByBookings = [];
      }
    },
    hq(newVal) {
      if (newVal) {
        this.booking.isXeroBooking = false;
      }
    },
    async "booking.customer.name"(newVal) {
      if (newVal === 'RESTOCK @HQ') {
        this.restock = true;
        this.booking.isXeroBooking = false;
      } else {
        if (!this.booking._id) {
          // Get previous additional address
          const temp = await BookingsHttp.searchForBookings(this.booking.customer.email).then(result => result.data);
          // eslint-disable-next-line no-console
          // console.log(temp);
          setTimeout(() => {
            if (temp.length > 0) {
              if (temp[0].customer && temp[0].customer.additionalAddress) {
                this.draw = false;
                this.booking.customer.additionalAddress = true;
                this.booking.customer.addAddress1 = temp[0].customer.addAddress1;
                this.booking.customer.addAddress2 = temp[0].customer.addAddress2;
                this.booking.customer.addCity = temp[0].customer.addCity;
                this.booking.customer.addCounty = temp[0].customer.addCounty;
                this.booking.customer.addPostCode = temp[0].customer.addPostCode;
                this.draw = true;
              }
            }
          }, 500);
        }
      }
    },
    restock(newVal) {
      if (newVal) {
        this.booking.customer = {name: "RESTOCK @HQ"};
      }
    },
    selectedAddress: {
      handler(newVal) {
        if (newVal && newVal.line_1) {
          if (this.booking.customer && this.booking.customer.name && !this.booking.customer.additionalAddress) {
            this.booking.customer.address1 = newVal.line_1;
            this.booking.customer.address2 = newVal.line_2;
            this.booking.customer.county = newVal.county;
            this.booking.customer.postcode = newVal.postcode;
            this.booking.customer.city = newVal.post_town;
          }
          if (this.booking.customer && this.booking.customer.name && this.booking.customer.additionalAddress) {
            this.booking.customer.addAddress1 = newVal.line_1;
            this.booking.customer.addAddress2 = newVal.line_2;
            this.booking.customer.addCounty = newVal.county;
            this.booking.customer.addPostCode = newVal.postcode;
            this.booking.customer.addCity = newVal.post_town;
          }
        }
      },
      deep: true,
      immediate: true
    },
    async searchAddress(val) {
      if (val && val.length < 5) return;
      if (val) {
        this.isLoadingAddress = true;
        try {
          this.addresses = await AddressHttp.fetchAddresses(val).then(result => result.data);
        } catch (e) {
          alert(e);
        } finally {
          this.isLoadingAddress = false;
        }
      }
    },
    async search(val) {
      if (val && val.length < 3) return;
      if (val) {
        this.isLoading = true;
        try {
          const temp = await CustomersHttp.searchForCustomer(val).then(result => result.data);
          temp.map(t => {
            t.display = `${t.name} - ${t.registration}`;
          });
          this.customers = temp;
        } catch (e) {
          alert(e);
        } finally {
          this.isLoading = false;
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
